import React from "react";
import { Link, useNavigate } from "react-router-dom";
import siteLogo from '../../assets/images/logo_new.png';
import siteLogoBlack from '../../assets/images/logo_white.png';

const CardEditHeader = () => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };
    return (
        <div className="cart-edit-header">
            <div className="preview-button">
                <Link to="/" className="site-logo">
                    <img className='white-logo' src={siteLogo} alt="site logo" />
                    <img className='black-logo' src={siteLogoBlack} alt="site logo" />
                    <i>portal</i>
                </Link>
                <Link className="card_prv_btn" to="#"><i class="ri-eye-line"></i> Preview</Link>
            </div>
        </div>
    );
}

export default CardEditHeader;